// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

import { cloneDeep } from 'lodash';

import {
  fetchFieldBoundaryData
} from 'boundaries/loaders';

// Util
import { treatErrorAs } from 'api/errors';


// constants
import { errorLevel } from 'constants/errors';

// Action Types
export const typePrefix = 'vra/fields/';
export const actions = [
  'SET_ALL_FIELDS',
  'SET_FIELDS',
  'SET_FIELD_AREA_BY_FIELD_UUID',
  'SWITCH_FIELD' // Analytics action.
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = {
    byId: {},
    byUuid: {}
  },
  action = {}
) {
  switch (action.type) {
    case actions.SET_ALL_FIELDS:
      return {
        ...state,
        byId: action.payload.byId,
        byUuid: action.payload.byUuid
      };

    case actions.SET_FIELDS:
      return {
        ...state,
        byId: {
          ...state.byId,
          ...action.payload.byId
        },
        byUuid: {
          ...state.byUuid,
          ...action.payload.byUuid
        }
      };

    case actions.SET_FIELD_AREA_BY_FIELD_UUID:
      const field = cloneDeep(state.byUuid[action.payload.fieldUuid]);
      field.area = action.payload.area;
      return {
        ...state,
        byId: {
          ...state.byId,
          [field.id]: field
        },
        byUuid: {
          ...state.byUuid,
          [field.uuid]: field
        }
      };

    default:
      return state;
  }
}

// Action Creators

export const setAllFields = (fields) => {
  return {
    type: actions.SET_ALL_FIELDS,
    payload: fields
  };
};

export const setFields = (fields) => {
  return {
    type: actions.SET_FIELDS,
    payload: fields
  };
};

export const setFieldAreaByFieldUuid = ({ area, fieldUuid }) => {
  return {
    type: actions.SET_FIELD_AREA_BY_FIELD_UUID,
    payload: { area, fieldUuid }
  };
};

export const fetchCentroidForFieldId = ({ fieldId, userId }) => { // TODO: belongs in loaders?
  return fetchFieldBoundaryData({ fieldId, userId })
  .then((response) => {
    return response.centroid;
  })
  .catch(treatErrorAs({ severity:errorLevel.INFO, message:`Error fetching centroid from homestead.`}));
};
